import { BookOpen } from "lucide-react";
import { Link } from "wouter";

interface SourceInfo {
  skill_name: string;
  category: string;
  source_file: string;
  chunk_type: string;
}

interface CitationBlockProps {
  sources: SourceInfo[];
}

export function CitationBlock({ sources }: CitationBlockProps) {
  // Deduplicate by skill_name
  const unique = sources.reduce<SourceInfo[]>((acc, s) => {
    if (!acc.some((a) => a.skill_name === s.skill_name)) {
      acc.push(s);
    }
    return acc;
  }, []);

  if (unique.length === 0) return null;

  return (
    <div className="mt-2 flex flex-wrap gap-1.5">
      {unique.map((source) => (
        <Link
          key={source.skill_name}
          to={`/explorer?search=${encodeURIComponent(source.skill_name)}`}
          className="inline-flex cursor-pointer items-center gap-1 rounded-md border border-border bg-background/50 px-2 py-0.5 text-[11px] text-muted-foreground transition-colors hover:border-primary/50 hover:bg-primary/20 hover:text-foreground"
        >
          <BookOpen className="h-3 w-3 shrink-0" />
          <span className="truncate max-w-[120px]">{source.skill_name}</span>
          <span className="text-[9px] opacity-60">{source.category}</span>
        </Link>
      ))}
    </div>
  );
}
